import { COLORS } from "@/common/constants";

const chartColors = {
    red: COLORS.SECONDARY,
    green: COLORS.GREEN_PRIMARY,
    blue: COLORS.BLUE_PRIMARY,
    yellow: '#d4a004',
    darkred: COLORS.PRIMARY,
    darkgreen: COLORS.GREEN_DARK,
    darkblue: COLORS.BLUE_DARK,
    orange: '#ffe100ff',
} as const;

export default chartColors;
